/*! Copyright (c) Safe As Milk. All rights reserved. */
import Cart from "cart-store";

class ProductForm extends HTMLElement {
    #boundSubmit;
    #eventAttached;
    static #formsBeingProcessed=[];
    constructor() {
        super();
        this.#boundSubmit = this.submit.bind(this);
    }
    connectedCallback() {
        this.#eventAttached = false;
        setTimeout((() => {
            this.form = this.querySelector("form");
            this.idInput = this.form.querySelector('input[name="id"]');
            this.submitButtons = this.form.querySelectorAll('[name="add"]');
            this.stagedActions = this.form.querySelectorAll("staged-action");
            this.idInput.removeAttribute("disabled");
            this.notifyOnAdd = this.hasAttribute("notify-on-add");
            this.redirectOnAdd = this.getAttribute("redirect-on-add");
            this.#eventAttached = true;
            this.form.addEventListener("submit", this.#boundSubmit);
        }));
    }
    disconnectedCallback() {
        if (this.#eventAttached) {
            this.#eventAttached = false;
            this.form.removeEventListener("submit", this.#boundSubmit);
        }
    }
    async submit(e) {
        e.preventDefault();
        const data = new FormData(e.target);

        // Personalization functionality
        const personalizationForm = this.form.querySelector('.js-personalization-form');

        if (!!(personalizationForm)) {
            const personalizationFormData = [];

            personalizationForm.querySelectorAll('input')?.forEach((input) => {
                personalizationFormData.push({
                    key: input.dataset.key,
                    value: input.value
                });
            });

            data.append('properties[_personalization]', JSON.stringify(personalizationFormData));
        }

        const uuidInput = this.form.querySelector('input[name="properties[_uuid]"]');

        if (!(uuidInput)) {
            const uuid = window.crypto.randomUUID();

            if (!(personalizationForm)) {
                // Add element in case customer wants to add more from the same product form
                this.form.insertAdjacentHTML('beforeend', `<input type="hidden" name="properties[_uuid]" value="${uuid}">`);
            }

            data.append('properties[_uuid]', uuid);
        }

        data.append('sections', sectionsToFetch);

        const item = Object.fromEntries(data.entries());
        try {
            this.removeError();
            if (this.redirectOnAdd && !ProductForm.#formsBeingProcessed.includes(this.form.id)) {
                ProductForm.#formsBeingProcessed.push(this.form.id);
            }
            if (!!(this.stagedActions) && this.stagedActions.length > 0) {
                this.stagedActions.forEach(async (stagedAction) => {
                    await stagedAction.setState("DOING");
                });
            }

            await Cart.add(item);

            if (this.redirectOnAdd) {
                ProductForm.#formsBeingProcessed = ProductForm.#formsBeingProcessed.filter((id => id !== this.form.id));
                if (ProductForm.#formsBeingProcessed.length === 0) {
                    window.location.href = this.redirectOnAdd;
                }
            }
            if (!!(this.stagedActions) && this.stagedActions.length > 0) {
                this.stagedActions.forEach(async (stagedAction) => {
                    await stagedAction.setState("DONE");
                });
            }
            const quickShop = this.closest("quick-shop");
            if (quickShop) {
                await quickShop.close();
            }
            if (this.notifyOnAdd) {
                await Cart.resetVariantsBeingAdded();
                if (!this.closest(".modal--cart")) {
                    const cart = document.querySelector(".modal--cart, .popup--cart-notification");
                    if (cart && !cart.shown) {
                        cart.open();
                    } else if (cart && cart.interval) {
                        cart.interval.reset();
                        cart.interval.start();
                    }
                }
            } else {
                await Cart.resetLatestAddedProduct();
                await Cart.resetVariantsBeingAdded(item.id);
            }
        } catch (error) {
            this.#renderError(error.message);
            if (!!(this.stagedActions) && this.stagedActions.length > 0) {
                this.stagedActions.forEach(async (stagedAction) => {
                    await stagedAction.setState("IDLE");
                });
            }
            if (this.redirectOnAdd) {
                ProductForm.#formsBeingProcessed = ProductForm.#formsBeingProcessed.filter((id => id !== this.form.id));
            }
        }
    }
    removeError() {
        const error = this.querySelector(".errors");
        if (!error) return;
        error.remove();
    }
    #renderError(message) {
        this.removeError();
        if (!!(this.submitButtons) && this.submitButtons.length > 0) {
            const error = document.createElement("div");
            error.classList.add("errors", "qty-error", "u-small");
            error.innerHTML = message;

            this.submitButtons.forEach((submitButton) => {
                submitButton.before(error);
            });
        }
    }
}

customElements.define("product-form", ProductForm);
//# sourceMappingURL=product-form.js.map
